import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { UserSingUpAPI } from '../../../redux/slices/UserSIgnUp';
import { Formik } from 'formik';
import { profSignUpvalidationSchema } from '../../../schemas/professionalSignUpSchema';
import GoogelMapAPI from '../../GoogelMapAPI/GoogelMapAPI';

const ProfSignUpForm = () => {

    const [getLocationAttributes, setGetLocationAttributes] = useState({})

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const loading = useSelector(state => state.UserSignUp.loading)

    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
    const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(!confirmPasswordVisible);

    const [addressData, setAddressData] = useState({
        address: getLocationAttributes?.address || '',
        longitude: getLocationAttributes?.longitude || '',
        latitude: getLocationAttributes?.latitude || '',
    });

    const handleSubmit = async (values) => {
        // const res = await dispatch(UserSingUpAPI(values));
        const res = await dispatch(UserSingUpAPI({ ...values, address: addressData?.address, longitude: addressData?.longitude, latitude: addressData?.latitude }));

        if (res?.payload?.status === 200 || res?.payload?.status === true) {
            navigate("/sign-up/email-varification");
        }
    };

    useEffect(() => {
        if (getLocationAttributes) {
            setAddressData({
                address: getLocationAttributes.address || '',
                longitude: getLocationAttributes.longitude || '',
                latitude: getLocationAttributes.latitude || '',
            });
        }
    }, [getLocationAttributes]);

    return (
        <div className="signup-form xl-pt-5 xl-pb-5 lg-pt-5 lg-pb-5 md-pt-5 md-pb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-7 col-lg-9 col-md-10">
                        <h1 className="main-form-heading">Sign Up</h1>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-xl-7 col-lg-9 col-md-10 auth-form-card auth-form-wide">
                        <Formik
                            initialValues={{
                                name: '',
                                email: '',
                                password: '',
                                confirm_password: '',
                                ss_number: '',
                                // address: getLocationAttributes?.address,
                                // longitude: getLocationAttributes?.longitude,
                                // latitude: getLocationAttributes?.latitude,
                                about: '',
                                profile: null,
                                certificate: null,
                                other: null,
                                role: 'professional',
                            }}
                            validationSchema={profSignUpvalidationSchema}
                            enableReinitialize
                            onSubmit={handleSubmit}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Full Name"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.name && errors.name && <div className="error">{errors.name}</div>}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Email"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.email && errors.email && <div className="error">{errors.email}</div>}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type={passwordVisible ? 'text' : 'password'}
                                            className="form-control pass-input"
                                            placeholder="Password"
                                            name="password"
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.password && errors.password && <div className="error">{errors.password}</div>}
                                        <i
                                            className={`fa-solid ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                            onClick={togglePasswordVisibility}
                                            style={{ cursor: 'pointer' }}
                                        ></i>
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type={confirmPasswordVisible ? 'text' : 'password'}
                                            className="form-control pass-input"
                                            placeholder="Confirm Password"
                                            name="confirm_password"
                                            value={values.confirm_password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.confirm_password && errors.confirm_password && (
                                            <div className="error">{errors.confirm_password}</div>
                                        )}
                                        <i
                                            className={`fa-solid ${confirmPasswordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                            onClick={toggleConfirmPasswordVisibility}
                                            style={{ cursor: 'pointer' }}
                                        ></i>
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Social Security Number"
                                            name="ss_number"
                                            value={values.ss_number}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.ss_number && errors.ss_number && <div className="error">{errors.ss_number}</div>}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <GoogelMapAPI setGetLocationAttributes={setGetLocationAttributes} />
                                        {/* {touched.address && errors.address && <div className="error">{errors.address}</div>} */}
                                    </div>

                                    <div className="mb-3 custom-input-box">
                                        <textarea
                                            className="form-control"
                                            placeholder="About Yourself"
                                            rows="3"
                                            name="about"
                                            value={values.about}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        ></textarea>
                                        {touched.about && errors.about && <div className="error">{errors.about}</div>}
                                    </div>

                                    <div className="flex-center-box mb-4">
                                        <div className="logo-box">
                                            <h3 className="second-text-heading mt-0">Profile Picture</h3>
                                            <label htmlFor="profilePicture" className="upload-image">
                                                <span>Upload Image</span>
                                            </label>
                                            <input
                                                type="file"
                                                className="d-none"
                                                id="profilePicture"
                                                name="profile"
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const file = e.currentTarget.files[0];
                                                    if (file && file.type.startsWith('image/')) {
                                                        setFieldValue('profile', file);
                                                    } else {
                                                        setFieldValue('profile', null);
                                                        alert('Please upload a valid image file.');
                                                    }
                                                }}
                                            />
                                            {values.profile && values.profile.type.startsWith('image/') && (
                                                <img
                                                    src={URL.createObjectURL(values.profile)}
                                                    alt="Uploaded Preview"
                                                    className="uploaded-image-preview"
                                                />
                                            )}
                                            {touched.profile && errors.profile && <div className="error">{errors.profile}</div>}
                                        </div>

                                        <div className="logo-box">
                                            <h3 className="second-text-heading mt-0">Professional Certificate</h3>
                                            <label htmlFor="professionalCertificate" className="upload-image">
                                                <span>Upload Document</span>
                                            </label>
                                            <input
                                                type="file"
                                                className="d-none"
                                                id="professionalCertificate"
                                                name="certificate"
                                                accept=".pdf, .doc, .docx, .txt, .xls"
                                                onChange={(e) => {
                                                    const file = e.currentTarget.files[0];
                                                    if (file && file.type.match('application/pdf') || file.type.match('application/msword') || file.type.match('application/vnd.openxmlformats-officedocument.wordprocessingml.document') || file.type.match('text/plain') || file.type.match('application/vnd.ms-excel')) {
                                                        setFieldValue('certificate', file);
                                                    } else {
                                                        setFieldValue('certificate', null);
                                                        alert('Please upload a valid document file.');
                                                    }
                                                }}
                                            />
                                            {values.certificate && (
                                                <p>{values.certificate.name}</p>
                                            )}
                                            {touched.certificate && errors.certificate && <div className="error">{errors.certificate}</div>}
                                        </div>
                                    </div>

                                    <div className="logo-box">
                                        <h3 className="second-text-heading mt-2">Other Supporting Document</h3>
                                        <label htmlFor="otherDocument" className="upload-image">
                                            <span>Upload Document</span>
                                        </label>
                                        <input
                                            type="file"
                                            className="d-none"
                                            id="otherDocument"
                                            name="other"
                                            accept=".pdf, .doc, .docx, .txt, .xls" // Accept only document files
                                            onChange={(e) => {
                                                const file = e.currentTarget.files[0];
                                                if (file && file.type.match('application/pdf') || file.type.match('application/msword') || file.type.match('application/vnd.openxmlformats-officedocument.wordprocessingml.document') || file.type.match('text/plain') || file.type.match('application/vnd.ms-excel')) {
                                                    setFieldValue('other', file);
                                                } else {
                                                    setFieldValue('other', null);
                                                    alert('Please upload a valid document file.');
                                                }
                                            }}
                                        />
                                        {values.other && (
                                            <p>{values.other.name}</p>
                                        )}
                                        {touched.other && errors.other && <div className="error">{errors.other}</div>}
                                    </div>

                                    <div className="submit-btn-form mt-5">
                                        <button
                                            type="submit"
                                            className="btn btn-primary ps-4 pe-4"
                                            disabled={loading}
                                        >
                                            {!loading ? (
                                                "Submit"
                                            ) : (
                                                <i
                                                    style={{ fontSize: "22px" }}
                                                    className="fa-solid fa-spinner fa-spin"
                                                ></i>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>

                        <div className="not-a-membder-box">
                            {/* <p>Log in via</p>
                            <div className="login-icons">
                                <i className="fa-brands fa-facebook-f" />
                                <i className="fa-brands fa-apple" />
                                <i className="fa-brands fa-google" />
                            </div> */}
                            <p className="member-text mt-0">
                                Not a member? <Link to="/profSignIn">Sign In</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfSignUpForm;